<template>
  <div>
    <PageSpinner :onloader="onloader" />

    <!-- HEADER -->
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-8 exam-header">
      <router-link to="/dashboard" class="text-white pl-3"
        >Dashboard</router-link
      >
      <span class="text-white px-2">› Exam</span>
    </base-header>

    <main
      class="container-fluid mt--7 exam-page"
      :class="{ 'access-state': !Openquestion }"
    >
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <section v-if="!Openquestion" class="access-card">
            <div class="access-icon"><i class="fa fa-clipboard-check"></i></div>
            <span class="eyebrow">STUDENT ASSESSMENT</span>
            <h1>Enter your exam access code</h1>
            <p>Use the code provided by your school to load your assessment.</p>
            <form
              class="access-form"
              @submit.prevent="GetSchoolQuestionsForExam">
              <label for="exam-access-code">Access code</label>
              <div class="access-input-row">
                <input
                  id="exam-access-code"
                  v-model.trim="AccessCodeval"
                  class="form-control"
                  placeholder="e.g. ABC123"
                  autocomplete="off"
                  required
                />
                <button
                  class="btn btn-primary"
                  type="submit"
                  :disabled="!AccessCodeval">
                  <i class="fa fa-arrow-right mr-1"></i>Continue
                </button>
              </div>
              <small
                ><i class="fa fa-lock mr-1"></i>Your exam access is private and
                tied to your school.</small
              >
            </form>
          </section>

          <section v-else class="exam-layout">
            <aside class="exam-sidebar">
              <div class="exam-status">
                <span class="status-dot" :class="{ live: StartExam }"></span
                >{{ StartExam ? "Assessment in progress" : "Ready to begin" }}
              </div>
              <div class="subject-card">
                <span class="eyebrow">CURRENT ASSESSMENT</span>
                <h1>{{ SubjectNameval || "Examination" }}</h1>
                <div class="exam-meta">
                  <span
                    ><i class="fa fa-calendar-alt"></i>{{ SchSessionval }} ·
                    {{ SchoolTermval }}</span
                  ><span
                    ><i class="fa fa-users"></i>{{ SchoolClassval }}
                    {{ ClassOptionval }}</span
                  >
                </div>
              </div>
              <div class="timer-card" :class="timerTone">
                <span><i class="fa fa-clock mr-1"></i>TIME REMAINING</span>
                <strong>{{ formattedTime }}</strong>
                <small>{{
                  StartExam
                    ? "Keep an eye on the clock"
                    : "The timer begins when you start"
                }}</small>
              </div>
              <div class="progress-card" v-if="StartExam">
                <div class="progress-copy">
                  <span>Completion</span
                  ><strong
                    >{{ answeredCount }} /
                    {{ QuestionSelected.length }} answered</strong
                  >
                </div>
                <div class="exam-progress">
                  <i :style="{ width: `${progressPercent}%` }"></i>
                </div>
              </div>
              <details v-if="CautionNoteval" class="instructions-card" open>
                <summary>
                  <i class="fa fa-info-circle mr-1"></i>Exam instructions
                </summary>
                <div class="instruction-copy" v-html="CautionNoteval"></div>
              </details>
            </aside>

            <div class="exam-content">
              <div v-if="!StartExam" class="start-card">
                <div class="start-icon"><i class="fa fa-book-open"></i></div>
                <span class="eyebrow">BEFORE YOU BEGIN</span>
                <h2>Take a moment to get ready</h2>
                <p>
                  Make sure you have enough time and a stable connection. Your
                  answers are saved as you work.
                </p>
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="startExam"
                >
                  Start exam <i class="fa fa-arrow-right ml-2"></i>
                </button>
              </div>

              <div v-else class="question-card">
                <div class="question-topline">
                  <div>
                    <span class="eyebrow">QUESTION {{ CurrentSNo }}</span>
                    <h2>Choose one answer</h2>
                  </div>
                  <span class="question-counter"
                    >{{ CurrentSNo }}
                    <small>of {{ NoofQuestiontoDisplayval }}</small></span
                  >
                </div>
                <div class="question-progress">
                  <i :style="{ width: `${questionProgress}%` }"></i>
                </div>
                <div class="question-body" v-html="CurrentQuestion"></div>
                <div
                  class="option-wrapper"
                  role="radiogroup"
                  aria-label="Answer choices"
                >
                  <div
                    v-for="(opt, index) in options"
                    :key="`${CurrentSNo}-${opt.id}`"
                    class="option-card"
                    :class="{ active: selectedAnswerId === opt.id }"
                    role="radio"
                    :aria-checked="selectedAnswerId === opt.id"
                    tabindex="0"
                    @click="selectOption(opt.id)"
                    @keydown.enter.prevent="selectOption(opt.id)"
                    @keydown.space.prevent="selectOption(opt.id)"
                  >
                    <span class="option-letter">{{
                      String.fromCharCode(65 + index)
                    }}</span>
                    <span class="option-body" v-html="opt.text"></span>
                    <i
                      v-if="selectedAnswerId === opt.id"
                      class="fa fa-check-circle option-check"
                    ></i>
                  </div>
                </div>
                <div class="question-actions">
                  <button
                    v-if="backbtn"
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="changeQuestion(-1)"
                  >
                    <i class="fa fa-arrow-left mr-1"></i>Previous
                  </button>
                  <span class="action-spacer"></span>
                  <button
                    class="btn btn-outline-danger"
                    type="button"
                    @click="submitqtn"
                  >
                    Submit exam
                  </button>
                  <button
                    v-if="hasSelectedAnswer"
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="clearAnswer"
                  >
                    Clear answer
                  </button>
                  <button
                    v-if="nextbtn"
                    class="btn btn-primary"
                    type="button"
                    @click="changeQuestion(1)"
                  >
                    Save &amp; next <i class="fa fa-arrow-right ml-1"></i>
                  </button>
                </div>
                <section class="question-palette">
                  <div class="palette-heading">
                    <div>
                      <h3>Question navigator</h3>
                      <p>
                        Jump to any question. Blue indicates a question has an
                        answer.
                      </p>
                    </div>
                    <span>{{ answeredCount }} answered</span>
                  </div>
                  <div class="palette-buttons">
                    <button
                      v-for="q in QuestionSelected"
                      :key="q.id"
                      type="button"
                      class="palette-button"
                      :class="{
                        answered: hasAnswer(q),
                        unanswered: !hasAnswer(q),
                        current: q.SNo === CurrentSNo,
                      }"
                      :aria-label="`Question ${q.SNo}${
                        hasAnswer(q) ? ', answered' : ', unanswered'
                      }${q.SNo === CurrentSNo ? ', current' : ''}`"
                      :aria-current="q.SNo === CurrentSNo ? 'step' : null"
                      @click="jumpTo(q.SNo)"
                    >
                      {{ q.SNo }}
                    </button>
                  </div>
                  <div class="palette-legend">
                    <span><i class="answered-legend"></i>Answered</span
                    ><span><i class="unanswered-legend"></i>Unanswered</span
                    ><span><i class="current-legend"></i>Current</span>
                  </div>
                </section>
              </div>
            </div>
          </section></card
        >
      </div>
    </main>
  </div>
</template>

<script>
import swal from "sweetalert2";
import PageSpinner from "@/components/PageSpinner";
import { getDB } from "@/rxdb";
import {
  queueRecord,
  registerSyncQueue,
  syncCollection,
} from "@/rxdb/offlineSync";
import store from "@/store";
import { getCurrentUserScope } from "@/rxdb/sessionScope";

export default {
  name: "Exam",
  components: { PageSpinner },

  data() {
    return {
      db: null,

      onloader: "none",
      Openquestion: false,
      StartExam: false,

      SubjectNameval: "",
      SchSessionval: "",
      SchoolTermval: "",
      SchoolClassval: "",
      ClassOptionval: "",
      CautionNoteval: "",

      AccessCodeval: "",
      Timerval: 0,
      NoofQuestiontoDisplayval: 0,

      QuestionSelected: [],
      CurrentQuestion: "",
      CurrentSNo: 1,
      selectedAnswerId: null,
      options: [],

      backbtn: false,
      nextbtn: true,

      timer: null,
      syncTimer: null,
      allowExit: false,
    };
  },

  computed: {
    formattedTime() {
      const m = Math.floor(this.Timerval / 60);
      const s = this.Timerval % 60;
      return `${m}:${s < 10 ? "0" : ""}${s}`;
    },
    timerTone() {
      if (!this.StartExam) return "";
      if (this.Timerval <= 60) return "critical";
      if (this.Timerval <= 300) return "warning";
      return "";
    },
    answeredCount() {
      return this.QuestionSelected.filter((question) =>
        this.hasAnswer(question)
      ).length;
    },
    progressPercent() {
      return this.QuestionSelected.length
        ? Math.round((this.answeredCount / this.QuestionSelected.length) * 100)
        : 0;
    },
    questionProgress() {
      const total = Number(this.NoofQuestiontoDisplayval) || 0;
      return total
        ? Math.min(100, Math.round((this.CurrentSNo / total) * 100))
        : 0;
    },
    hasSelectedAnswer() {
      return this.hasAnswer({ SelectedAnswerId: this.selectedAnswerId });
    },
  },

  async created() {
    this.db = await getDB();
    window.addEventListener("beforeunload", this.blockExit);
  },

  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.syncTimer);
    window.removeEventListener("beforeunload", this.blockExit);
  },

  beforeRouteLeave(to, from, next) {
    if (this.StartExam && !this.allowExit) {
      swal.fire("Submit exam before leaving!");
      next(false);
    } else {
      next();
    }
  },

  methods: {
    hasAnswer(question) {
      const answer = question.SelectedAnswerId;
      if (answer === null || answer === undefined) return false;
      if (typeof answer === "string") return answer.trim().length > 0;
      if (Array.isArray(answer)) return answer.length > 0;
      return true;
    },
    /* ACCESS */
    async GetSchoolQuestionsForExam() {
      this.Openquestion = false;
      this.StartExam = false;
      this.onloader = "flex";
      await this.fetchRemoteExam();
    },

    applyExamHeader(h) {
      if (!h) return;
      Object.assign(this, {
        SubjectNameval: h.subjectName,
        SchSessionval: h.schoolSession,
        SchoolTermval: h.schoolTerm,
        SchoolClassval: h.schoolClass,
        ClassOptionval: h.classOption,
        CautionNoteval: h.cautionNote,
        NoofQuestiontoDisplayval: h.noofQuestiontoDisplay,
        Timerval: Number(h.examPeriod) || 0,
      });
    },

    async fetchRemoteExam() {
      try {
        const resp = await this.$store.dispatch(
          "SchoolQuestion/GetSchoolQuestionsForExam",
          this.AccessCodeval
        );

        if (resp.responseCode !== "00") {
          await swal.fire(
            "Unable to load exam",
            resp.responseMessage || "Check the access code and try again.",
            "error"
          );
          return;
        }

        const h = resp.data.headerDetails;
        this.applyExamHeader(h);

        await this.clearCachedExam(this.AccessCodeval);

        const ownerId = getCurrentUserScope();
        const docs = resp.data.questions.map((q) => ({
          id: `${ownerId}:${this.AccessCodeval}:${q.questionId}_${q.sNo}`,
          ownerId,
          examCode: this.AccessCodeval,
          examHeader: h,
          SNo: q.sNo,
          QuestionId: q.questionId,
          Question: q.examQuestion,
          OptionA: q.optionA,
          OptionB: q.optionB,
          OptionC: q.optionC,
          OptionD: q.optionD,
          OptionAId: q.optionAId,
          OptionBId: q.optionBId,
          OptionCId: q.optionCId,
          OptionDId: q.optionDId,
          SelectedAnswerId: null,
          Synced: false,
          syncStatus: "synced",
          syncError: null,
          updatedAt: new Date().toISOString(),
        }));

        await this.db.schoolquestions.bulkUpsert(docs);
        await this.refreshPalette();

        this.Openquestion = true;
        registerSyncQueue("cbtsubmissions", (current) =>
          store.dispatch(
            "SchoolQuestion/SubmitSchoolStudentQuestion",
            current.payload
          )
        );
      } catch (error) {
        await swal.fire(
          "Unable to load exam",
          error.message || "Please check your connection and try again.",
          "error"
        );
      } finally {
        this.onloader = "none";
      }
    },

    async clearCachedExam(examCode) {
      const [questionDocs, submissionDocs] = await Promise.all([
        this.db.schoolquestions.find({ selector: { ownerId: getCurrentUserScope(), examCode } }).exec(),
        this.db.cbtsubmissions.find({ selector: { ownerId: getCurrentUserScope() } }).exec(),
      ]);
      const submissionPrefix = `submission:${getCurrentUserScope()}:${examCode}:`;

      await Promise.all([
        ...questionDocs.map((doc) => doc.remove()),
        ...submissionDocs
          .filter((doc) => doc.toJSON().ownerId === getCurrentUserScope() && doc.toJSON().id.startsWith(submissionPrefix))
          .map((doc) => doc.remove()),
      ]);
    },

    async startExam() {
      this.StartExam = true;
      await this.loadQuestion(1);
      this.startTimer();
      this.startBackgroundSync();
    },

    async loadQuestion(SNo) {
      const doc = await this.db.schoolquestions
        .findOne({
          selector: { ownerId: getCurrentUserScope(), examCode: this.AccessCodeval, SNo },
        })
        .exec();

      if (!doc) return;

      const q = doc.toJSON();
      this.CurrentSNo = q.SNo;
      this.CurrentQuestion = q.Question;
      this.selectedAnswerId = q.SelectedAnswerId;

      this.options = [
        { id: q.OptionAId, text: q.OptionA },
        { id: q.OptionBId, text: q.OptionB },
        { id: q.OptionCId, text: q.OptionC },
        { id: q.OptionDId, text: q.OptionD },
      ];

      this.backbtn = SNo > 1;
      this.nextbtn = SNo < this.NoofQuestiontoDisplayval;
    },

    selectOption(id) {
      this.selectedAnswerId = id;
      const currentQuestion = this.QuestionSelected.find(
        (question) => question.SNo === this.CurrentSNo
      );
      if (currentQuestion) currentQuestion.SelectedAnswerId = id;
    },

    async clearAnswer() {
      this.selectedAnswerId = null;
      const currentQuestion = this.QuestionSelected.find(
        (question) => question.SNo === this.CurrentSNo
      );
      if (currentQuestion) currentQuestion.SelectedAnswerId = null;
      await this.saveAnswer();
    },

    async saveAnswer() {
      const doc = await this.db.schoolquestions
        .findOne({
          selector: { ownerId: getCurrentUserScope(), examCode: this.AccessCodeval, SNo: this.CurrentSNo },
        })
        .exec();

      if (doc) {
        const previousQuestion = doc.toJSON();
        const shouldSyncAnswer =
          this.hasSelectedAnswer ||
          this.hasAnswer({
            SelectedAnswerId: previousQuestion.SelectedAnswerId,
          });

        await doc.atomicPatch({
          SelectedAnswerId: this.selectedAnswerId,
          Synced: false,
          syncStatus: "pending",
          updatedAt: new Date().toISOString(),
        });

        if (shouldSyncAnswer) {
          const question = previousQuestion;
          await queueRecord("cbtsubmissions", {
            id: `submission:${getCurrentUserScope()}:${this.AccessCodeval}:${question.QuestionId}`,
            entityKey: `${this.AccessCodeval}:${question.QuestionId}`,
            payload: {
              QuestionId: question.QuestionId,
              SelectedAnswerId: this.selectedAnswerId,
              ClientRequestId: `submission:${getCurrentUserScope()}:${this.AccessCodeval}:${question.QuestionId}`,
            },
          });
        }
      }
      await this.refreshPalette();
    },

    async changeQuestion(step) {
      await this.saveAnswer();
      await this.loadQuestion(this.CurrentSNo + step);
    },

    async jumpTo(SNo) {
      if (SNo === this.CurrentSNo) return;
      await this.saveAnswer();
      this.loadQuestion(SNo);
    },

    async refreshPalette() {
      const docs = await this.db.schoolquestions
        .find({
          selector: { ownerId: getCurrentUserScope(), examCode: this.AccessCodeval },
          sort: [{ SNo: "asc" }],
        })
        .exec();
      this.QuestionSelected = docs.map((d) => d.toJSON());
    },

    startTimer() {
      this.timer = setInterval(() => {
        if (--this.Timerval <= 0) {
          clearInterval(this.timer);
          this.submitqtn();
        }
      }, 1000);
    },

    startBackgroundSync() {
      this.syncTimer = setInterval(() => {
        if (navigator.onLine) this.syncAnswers();
      }, 15000);
    },

    async syncAnswers() {
      await syncCollection("cbtsubmissions", (current) =>
        store.dispatch(
          "SchoolQuestion/SubmitSchoolStudentQuestion",
          current.payload
        )
      );

      const submissions = await this.db.cbtsubmissions
        .find({
          selector: { ownerId: getCurrentUserScope(), syncStatus: "synced" },
        })
        .exec();
      await Promise.all(
        submissions.map(async (submission) => {
          const questionId = submission.toJSON().payload.QuestionId;
          const question = await this.db.schoolquestions
            .findOne({
              selector: { ownerId: getCurrentUserScope(), QuestionId: questionId },
            })
            .exec();
          if (question)
            await question.atomicPatch({ Synced: true, syncStatus: "synced" });
        })
      );
    },

    async submitqtn() {
      const r = await swal.fire({
        title: "Submit exam?",
        icon: "warning",
        showCancelButton: true,
      });

      if (!r.isConfirmed) return;

      this.onloader = "flex";
      clearInterval(this.timer);
      clearInterval(this.syncTimer);

      await this.saveAnswer();
      this.syncAnswers();

      this.allowExit = true;
      this.onloader = "none";

      swal.fire("Submitted", "Exam completed", "success");
      this.$router.replace("/student/exam");
    },

    blockExit(e) {
      if (this.StartExam && !this.allowExit) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
  },
};
</script>

<style scoped>
.exam-page {
  max-width: 1500px;
  min-height: calc(100vh - 210px);
  padding-bottom: 40px;
}

.exam-page.access-state {
  display: flex;
  align-items: center;
  justify-content: center;
}

.access-card,
.exam-sidebar,
.exam-content,
.question-card {
  border: 1px solid #e6ebf1;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 34px rgba(29, 47, 68, 0.07);
}

.access-card {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 34px;
  text-align: center;
}

.access-icon,
.start-icon {
  display: grid;
  width: 58px;
  height: 58px;
  margin: 0 auto 18px;
  place-items: center;
  border-radius: 16px;
  background: #eaf4ee;
  color: #23815c;
  font-size: 23px;
}

.eyebrow {
  color: #56836f;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.12em;
}

.access-card h1 {
  margin: 8px 0;
  color: #23344a;
  font-size: 25px;
  font-weight: 750;
}

.access-card > p,
.start-card > p {
  margin: 0 auto;
  max-width: 440px;
  color: #778497;
  font-size: 14px;
}

.access-form {
  margin: 24px auto 0;
  max-width: 380px;
  text-align: left;
}

.access-form label {
  color: #46566a;
  font-size: 12px;
  font-weight: 700;
}

.access-input-row {
  display: flex;
  gap: 9px;
}

.access-input-row .form-control {
  min-width: 0;
  min-height: 40px;
  border-color: #dce3ea;
  border-radius: 7px;
}

.access-input-row .btn {
  flex: 0 0 auto;
  padding: 8px 13px;
}

.access-input-row .btn,
.start-card .btn,
.question-actions .btn {
  border-radius: 7px;
  font-weight: 650;
}

.access-form small {
  display: block;
  margin-top: 10px;
  color: #8793a3;
}

.exam-layout {
  display: grid;
  grid-template-columns: minmax(250px, 310px) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.exam-sidebar {
  position: sticky;
  top: 18px;
  overflow: hidden;
}

.exam-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 13px 18px;
  border-bottom: 1px solid #edf0f4;
  color: #68778a;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a3afbd;
}

.status-dot.live {
  background: #2b986c;
  box-shadow: 0 0 0 4px #e6f5ed;
}

.subject-card {
  padding: 20px 19px;
}

.subject-card h1 {
  margin: 7px 0 15px;
  color: #25374e;
  font-size: 21px;
  font-weight: 750;
  line-height: 1.25;
}

.exam-meta {
  display: grid;
  gap: 9px;
  color: #718094;
  font-size: 12px;
}

.exam-meta span {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.exam-meta i {
  width: 15px;
  margin-top: 2px;
  color: #5c8b78;
  text-align: center;
}

.timer-card {
  display: grid;
  gap: 4px;
  margin: 0 16px 14px;
  padding: 17px;
  border: 1px solid #e2eee8;
  border-radius: 10px;
  background: #f3faf6;
  color: #39755d;
}

.timer-card > span {
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.09em;
}

.timer-card strong {
  color: #245c44;
  font-size: 35px;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}

.timer-card small {
  color: #758a7f;
  font-size: 11px;
}

.timer-card.warning {
  border-color: #f1dfb8;
  background: #fff9ed;
  color: #9a6b17;
}

.timer-card.warning strong {
  color: #9a6b17;
}

.timer-card.critical {
  border-color: #f0c9ca;
  background: #fff2f2;
  color: #a94448;
  animation: timer-pulse 1.4s ease-in-out infinite;
}

.timer-card.critical strong {
  color: #a12f36;
}

.progress-card {
  padding: 0 18px 18px;
}

.progress-copy {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  color: #718094;
  font-size: 10px;
}

.progress-copy strong {
  color: #45566d;
}

.exam-progress,
.question-progress {
  height: 6px;
  overflow: hidden;
  border-radius: 5px;
  background: #edf1f4;
}

.exam-progress i,
.question-progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #32906a;
  transition: width 0.25s ease;
}

.instructions-card {
  margin: 0 16px 16px;
  padding: 13px;
  border: 1px solid #e8edf2;
  border-radius: 9px;
  background: #fafbfd;
}

.instructions-card summary {
  color: #4f6279;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.instruction-copy {
  padding-top: 10px;
  color: #778497;
  font-size: 12px;
  line-height: 1.55;
}

.exam-content {
  min-width: 0;
  padding: 20px;
}

.start-card {
  padding: 45px 24px;
  text-align: center;
}

.start-card h2 {
  margin: 8px 0;
  color: #26384f;
  font-size: 22px;
  font-weight: 750;
}

.start-card .btn {
  margin-top: 24px;
  padding: 11px 21px;
}

.question-card {
  padding: 25px;
  border-radius: 11px;
  box-shadow: none;
}

.question-topline {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  margin-bottom: 14px;
}

.question-topline h2 {
  margin: 4px 0 0;
  color: #2c3d53;
  font-size: 17px;
  font-weight: 700;
}

.question-counter {
  color: #2c6e91;
  font-size: 21px;
  font-weight: 750;
  white-space: nowrap;
}

.question-counter small {
  color: #8390a0;
  font-size: 11px;
  font-weight: 600;
}

.question-progress {
  margin-bottom: 21px;
}

.question-progress i {
  background: #438bae;
}

.question-body {
  margin-bottom: 22px;
  color: #2d3d52;
  font-size: 16px;
  line-height: 1.7;
}

.question-body >>> img,
.option-body >>> img {
  max-width: 100%;
  height: auto;
}

.option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 13px 15px;
  border: 1px solid #dfe6ec;
  border-radius: 9px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease,
    box-shadow 0.15s ease;
}

.option-card:hover,
.option-card:focus {
  outline: 0;
  border-color: #83b3a0;
  box-shadow: 0 0 0 3px rgba(57, 139, 103, 0.09);
}

.option-body {
  flex: 1;
  min-width: 0;
  color: #43546a;
  font-size: 14px;
  line-height: 1.5;
}

.option-letter {
  display: grid;
  flex: 0 0 29px;
  width: 29px;
  height: 29px;
  place-items: center;
  border: 1px solid #dce4eb;
  border-radius: 7px;
  background: #f7f9fb;
  color: #607187;
  font-size: 11px;
  font-weight: 750;
}

.option-card.active {
  border-color: #4a9a76;
  background: #f3faf6;
  box-shadow: 0 0 0 2px rgba(57, 139, 103, 0.08);
}

.option-card.active .option-letter {
  border-color: #438e6d;
  background: #398b67;
  color: #fff;
}

.option-check {
  color: #31815e;
  font-size: 18px;
}

.question-actions {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 24px;
  padding-top: 17px;
  border-top: 1px solid #edf0f3;
}

.action-spacer {
  flex: 1;
}

.question-palette {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #edf0f3;
}

.palette-heading {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 13px;
}

.palette-heading h3 {
  margin: 0 0 3px;
  color: #34475e;
  font-size: 13px;
  font-weight: 750;
}

.palette-heading p,
.palette-heading > span {
  margin: 0;
  color: #8190a0;
  font-size: 10px;
}

.palette-heading > span {
  white-space: nowrap;
}

.palette-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(39px, 1fr));
  gap: 7px;
}

.palette-button {
  position: relative;
  min-height: 36px;
  border: 1px solid #dfe5eb;
  border-radius: 7px;
  background: #fff;
  color: #617187;
  font-size: 11px;
  font-weight: 700;
}

.palette-button.answered {
  border-color: #237a55;
  background: #27845d;
  color: #fff;
}

.palette-button.current {
  z-index: 1;
  border-color: #183f64;
  outline: 2px solid #183f64;
  outline-offset: 1px;
  box-shadow: 0 0 0 3px rgba(24, 63, 100, 0.12);
}

.palette-button.current::after {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #183f64;
  content: "";
}

.palette-button.answered.current::after {
  background: #fff;
}

.palette-button:focus-visible {
  outline: 2px solid #183f64;
  outline-offset: 2px;
}

.palette-button:hover {
  filter: brightness(0.96);
}

.palette-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
  color: #7c899a;
  font-size: 10px;
}

.palette-legend span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.palette-legend i {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.answered-legend {
  background: #27845d;
}

.unanswered-legend {
  border: 1px solid #cad3dc;
  background: #fff;
}

.current-legend {
  background: #347ca1;
}

@keyframes timer-pulse {
  50% {
    box-shadow: 0 0 0 4px rgba(169, 68, 72, 0.08);
  }
}

@media (max-width: 991px) {
  .exam-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .exam-sidebar {
    position: static;
  }

  .subject-card {
    padding-bottom: 14px;
  }

  .timer-card {
    margin: 0 16px 15px;
  }
}

@media (max-width: 575px) {
  .exam-page {
    padding-right: 10px;
    padding-left: 10px;
  }

  .access-card {
    padding: 28px 18px;
  }

  .access-card h1 {
    font-size: 21px;
  }

  .access-input-row {
    flex-direction: column;
  }

  .exam-content {
    padding: 10px;
  }

  .question-card {
    padding: 16px 13px;
  }

  .question-body {
    font-size: 14px;
  }

  .question-actions {
    flex-wrap: wrap;
  }

  .question-actions .action-spacer {
    display: none;
  }

  .question-actions .btn {
    flex: 1 1 auto;
  }

  .palette-heading {
    flex-direction: column;
  }
}
</style>
